<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <EditForm
          ref="editForm"
          :account-id="accountId"
        />
        <MigrateDialog
          :is-visible="showMigrateDialog"
          @close="showMigrateDialog = false"
          @migrate="showMigrateDialog = false"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import EditForm from '@/components/Application/Manage/Account/EditForm'
import MigrateDialog from '@/components/Application/Manage/Account/MigrateDialog'

export default {
  components: {
    EditForm,
    MigrateDialog
  },
  data () {
    return {
      showMigrateDialog: false,
      accountId: this.$route.params.accountId,
      actions: [
        [
          {
            name: 'Open360 Sync',
            icon: ['fal', 'rocket'],
            event: () => {
              this.showMigrateDialog = true
            }
          }
        ],
        [
          {
            name: 'Save',
            icon: ['fal', 'save'],
            event: () => {
              this.$refs.editForm.saveAccountEdit()
            }
          },
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: () => {
              this.$refs.editForm.readAccount()
            }
          }
        ]
      ],
      breadcrumb: {
        name: 'Account',
        route: { name: 'manage-accounts-account-configurations-edit', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
